export default __webpack_public_path__ + "static/media/assessment-summary.06c60168.png";